import { clearSection } from 'dmpconnectjsapp-base/actions';
import { apiSections } from 'dmpconnectjsapp-base/constants';
import { isReady } from 'dmpconnectjsapp-base/helpers/common';
import React from 'react'
import { Alert, Button, Card, Col, Modal, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';

function ServiceResultModal({dispatch, sendHttpRequest, currentIndex, setCurrentIndex, vitaleIndex, docInfo}) {
  return (
    <Modal show={isReady(sendHttpRequest) && sendHttpRequest.i_httpStatus === 200 && currentIndex === vitaleIndex} onHide={() => {
      dispatch(clearSection(apiSections.SEND_HTTP_REQUEST));
      setCurrentIndex(null);
    }} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Résultat de la recherche</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col>
            {docInfo.Code && docInfo.Code === "00" ? (
            <Alert variant="info" className="mb-0">
              {docInfo.Libelle || "Non renseigné"}
            </Alert>
            ) : (
            <Alert variant="danger" className="mb-0">
              {docInfo.Libelle || "Non renseigné"}
            </Alert>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Card className="mb-3 h-100">
              <Card.Header>
                <Card.Title className="mb-0">Médecin traitant</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row className="mb-2">
                  <Col sm={5}><strong>Nom :</strong></Col>
                  <Col sm={7}>{docInfo.NomUsage || "Non renseigné"}</Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={5}><strong>Prénom :</strong></Col>
                  <Col sm={7}>{docInfo.Prenom || "Non renseigné"}</Col>
                </Row>
                
                <hr className="my-3" />
                
                <Row className="mb-2">
                  <Col sm={5}><strong>PSAM :</strong></Col>
                  <Col sm={7}>
                    {docInfo.PSAM || "Non renseigné"}
                  </Col>
                </Row>
                {docInfo.ADELI && 
                <Row className="mb-2">
                  <Col sm={5}><strong>ADELI :</strong></Col>
                  <Col sm={7}>
                    {docInfo.ADELI || "Non renseigné"}
                  </Col>
                </Row>
                }
                {docInfo.RPPS &&
                <Row className="mb-2">
                  <Col sm={5}><strong>RPPS :</strong></Col>
                  <Col sm={7}>
                    {docInfo.RPPS || "Non renseigné"}
                  </Col>
                </Row>
                }
                <Row className="mb-2">
                  <Col sm={7}>
                    {`${docInfo.numeroVoie || ""} ${docInfo.indiceRepetition || ""} ${docInfo.typeVoie || ""} ${docInfo.nomVoie || ""}`.trim() || ""}
                    {docInfo.complement && (
                      <div>{docInfo.complement}</div>
                    )}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={7}>{docInfo.codePostal || ""}</Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={7}>{docInfo.commune || ""}</Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={7}>{docInfo.codePays || ""}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="mb-3 h-100">
              <Card.Header>
                <Card.Title className="mb-0">Information patient</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row className="mb-2">
                  <Col sm={6}><strong>Date de naissance :</strong></Col>
                  <Col sm={6}>{moment(docInfo.DateNai).format("DD/MM/YYYY") || "Non renseigné"}</Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={6}><strong>Rang de naissance :</strong></Col>
                  <Col sm={6}>{docInfo.RangNai || "Non renseigné"}</Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={6}><strong>NIR bénéficiaire :</strong></Col>
                  <Col sm={6}>
                    {`${docInfo.Num || ""}` || "Non renseigné"}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col sm={6}><strong>Clé bénéficiaire :</strong></Col>
                  <Col sm={6}>
                    {docInfo.Cle || "Non renseigné"}
                  </Col>
                </Row>
                {"Num_1" in docInfo && (
                  <>
                    <Row className="mb-2">
                      <Col sm={6}><strong>NIR ouvrant droit :</strong></Col>
                      <Col sm={6}>
                        {`${docInfo.Num_1 || ""}` || "Non renseigné"}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm={6}><strong>Clé ouvrant droit :</strong></Col>
                      <Col sm={6}>
                        {docInfo.Cle_1 || "Non renseigné"}
                      </Col>
                    </Row>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => {dispatch(clearSection(apiSections.SEND_HTTP_REQUEST))}}>Fermer</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ServiceResultModal

ServiceResultModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sendHttpRequest: PropTypes.object,
  currentIndex: PropTypes.number,
  setCurrentIndex: PropTypes.func.isRequired,
  vitaleIndex: PropTypes.number,
  docInfo: PropTypes.object.isRequired,
}
ServiceResultModal.defaultProps = {
  vitaleIndex: undefined,
  currentIndex: undefined,
  sendHttpRequest: {},
}
